/* eslint-disable import/prefer-default-export */

export const isLocalEnvironment = (location = window.location) =>
  location.hostname === "localhost";
